import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl, getAEMBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';

export const getCheckoutCQ = () => {
  const apiURL = `${getAEMBaseUrl('content/vcg')}${apiUrls().checkoutCaas}`;
  return HttpService.post(apiURL);
};

export const getCheckoutDetailsCall = (data) => {
  console.info('from sagas.helper-->', data);
  const postData = {
    clientCorrelationId: '',
    customerTypeParam: null,
    optimizeSDD: 'N',
    cart: data?.cart ? data?.cart : false,
    customerAgreements: data?.customerAgreements ? data?.customerAgreements : false,
    installmentContracts: false,
    paymentOptions: data?.paymentOptions ? data?.paymentOptions : false,
    shippingOptions: data?.shippingOptions ? data?.shippingOptions : false,
    smsEnabledOptions: false,
    iconicFlags: {
      disableISPU: false,
      disableSDD: false,
      disableISAAC: false,
      disableEdgeUpISPUSDD: false,
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().getCheckoutDetailsurl}`;
  return HttpService.post(apiURL, postData);
};
